module.exports = __webpack_public_path__ + "img/billi_headshot.485dd738.png";